import firebase  from 'firebase/app';
import 'firebase/firestore'


export function listAssessments() {
    const firestore = firebase.firestore()
    console.log('test')
    firestore.collection('assessments')
    .where('company.id','==','JFC')
    .get().then(snapshot => snapshot.docs.map(doc => {
        const data = doc.data()
        //doc.ref.delete().then(data => console.log('deletedned'))
        //firestore.collection('employees').doc(data.employee.id).delete().then(data => console.log('deleted'))
        console.log(data.rater.id + ' ' + data.employee.id)
    }  ))
}

/**
 * generatePrefixes('Jun 11 FLP Sup','flpsup20190611','flp_sup_2019_act',9)
 */
export function generatePrefixes(firstName, prefix, activity,total) {
    let prefixes = []
    let zero = '0'
    for(let i = 0; i < total; i++ ) {
        const index = i + 1
        if (index > 9) zero = ''
        const idPrefix = {
            activity,
            ee: prefix + zero + index,
            a: prefix + 'a_' + zero + index,
            firstName,
            lastName: zero + index

        }
        prefixes.push(idPrefix)
    }
    return prefixes
}

/**
 * generateAssesments('8b5uVXyVLzXm89QKOKYZWt3vn9Y2',prefixes)
 */
export function generateAssesments(raterId,prefixes) {
    const firestore = firebase.firestore()

    return prefixes.map(prefix => {
        return firestore.collection('employees').doc(prefix.ee).set({ 
            company: {id: 'JFC'}, firstName: prefix.firstName, lastName: prefix.lastName })
            .then(employee => {
                firestore.collection('assessmentsByRater').doc(prefix.a).set({ 
                    company: {id: 'JFC'}, answers:[], 
                    activities: [firestore.collection('activities').doc(prefix.activity + '1'),
                        firestore.collection('activities').doc(prefix.activity + '2'),
                        firestore.collection('activities').doc(prefix.activity + '3')],
                    rater: firestore.collection('users').doc(raterId),
                    employee: firestore.collection('employees').doc(prefix.ee)
                })
                console.log('done' + prefix)
            })
    })
}

export function generateAccounts() {
    const firestore = firebase.firestore()

    const raterId = '8b5uVXyVLzXm89QKOKYZWt3vn9Y2'


    // admin 3UL3EKcdqMYzPIoL6BSAnQMWxhq2
    // dette ws5nmuex2hTmyDUL8EbaMX4P68V2
    //carol 0ErUgO6YfSSUZRv8A2fesyJpcOJ3
    //calvin PF9v2qzTQ4RQCl9MoYM6BNDMI1r1
    // ato RLbjQRXPeCRl0VQLsWGHjNXE8Jk2

    // ruby 2KaS72yuFfagpMXKoeoLHnwdAV32

    // kath 8b5uVXyVLzXm89QKOKYZWt3vn9Y2
/*
ELP elp_act1
FLP opS flp_ops_act1
LEAP lead_act1
Lead lead_actb1
*/


    const prefix = 'flpops20180918_'

    let zero = '0'
    for(let i = 1; i < 5; i++ ) {
        if (i > 9) zero = ''
        
        firestore.collection('employees').doc(prefix + zero + i).set({ 
            company: {id: 'JFC'}, firstName: 'Sep 18 FLP Ops', lastName: ''  + i })
            .then(employee => {
                firestore.collection('assessmentsByRater').doc(prefix + 'a_' + zero + i).set({ 
                    company: {id: 'JFC'}, answers:[], 
                    activities: [firestore.collection('activities').doc('flp_ops_act1'),
                        firestore.collection('activities').doc('flp_ops_act2'),
                        firestore.collection('activities').doc('flp_ops_act3')],
                    rater: firestore.collection('users').doc(raterId),
                    employee: firestore.collection('employees').doc(prefix + zero + i)
                })
                console.log('done' + prefix)
            })

    }

}

export function generateAccounts0() {
    const firestore = firebase.firestore()

    const raterId = '3UL3EKcdqMYzPIoL6BSAnQMWxhq2'


    // admin 3UL3EKcdqMYzPIoL6BSAnQMWxhq2
    // dette ws5nmuex2hTmyDUL8EbaMX4P68V2
    //carol 0ErUgO6YfSSUZRv8A2fesyJpcOJ3
    //calvin PF9v2qzTQ4RQCl9MoYM6BNDMI1r1
    // ato RLbjQRXPeCRl0VQLsWGHjNXE8Jk2

    // ruby 2KaS72yuFfagpMXKoeoLHnwdAV32

    for(let i = 81; i < 91; i++ ) {
        
        
    firestore.collection('employees').doc('candidate0' + i).set({ 
        company: {id: 'JFC'}, firstName: 'Candidate 0' + i, lastName: 'JFC' })
        .then(employee => {
            firestore.collection('assessmentsByRater').doc('assessment0' + i).set({ 
                company: {id: 'JFC'}, answers:[], 
                activities: [firestore.collection('activities').doc('P6woVm0TX8pA5yGRYxK1'),
                    firestore.collection('activities').doc('Rpqn0LibUTqoCvHYmKd5'),
                    firestore.collection('activities').doc('1uYo275xyalvfB5H0Kk3')],
                rater: firestore.collection('users').doc(raterId),
                employee: firestore.collection('employees').doc('candidate0' + i)
             })
            console.log('done')
        })

    }

}


// WEBPACK FOOTER //
// ./src/admin/services/generate-accounts.js